import cookies from 'js-cookie';
import { AccountType, addonLearnMoreType } from '@/common/constants';
import { toThousands } from '@/utils/money';
import { translation } from '@/plugins/i18n';

export const ZOOM_CSRF_TOKEN = 'ZOOM-CSRFTOKEN';

/**
 *
 * @param {*} url
 * @param {*} method
 * @param {*} data
 */
export const formJump = (url, method = 'POST', data = null) => {
  const form = document.createElement('form');
  form.action = url;
  form.method = method;
  form.id = 'jump_form';
  form.class = 'hidden_element';
  if (data) {
    for (let key in data) {
      if (data[key] === undefined) {
        continue;
      }
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    const input = document.getElementsByName(ZOOM_CSRF_TOKEN);
    if (input.length !== 0) {
      form.appendChild(input[0]);
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const $cookie = cookies.withConverter({
  write: function (value) {
      return value;
  },
  read: cookies.converter.read,
});

export const isPaidAccount = (accountType) => {
  // exclude net new/free w/wo cc
  return [
    AccountType.ACCOUNT_UNKNOWN,
    AccountType.ACCOUNT_FREE_WITH_CC,
    AccountType.ACCOUNT_FREE_WITHOUT_CC
  ].includes(accountType) === false;
}

export const capitalizeFirstLetter = (string = '') => {
  if (typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const capacityFormatter = (capacity) => {
  const unitMap = {
    1000000: translation('billing.event_services.unit.million_1_uppercase')
  };
  return unitMap?.[capacity] || toThousands(capacity);
}

export const toLowercaseString = (str) => {
  return str?.toLowerCase?.() ?? str;
}

export const toUpCaseString = (str) => {
  return str?.toUpperCase?.() ?? str;
}

export const stripHTML = (htmlStr) => {
  const div = document.createElement('div');
  div.innerHTML = htmlStr;
  return div.textContent || div.innerText || '';
}

export const deduplicate = arr => [...new Set(arr)];

export const getAddonLearnMoreMap = () => {
  return {
    zoom_scheduler: {type: addonLearnMoreType.ADDON, dialogName: 'zsched'},
    large_meeting: {type: addonLearnMoreType.ADDON, dialogName: 'large'},
    cmr: {type: addonLearnMoreType.ADDON, dialogName: 'cmr'},
    translation_captions: {type: addonLearnMoreType.ADDON, dialogName: 'translation_captions'},
    webinar: {type: addonLearnMoreType.PLAN, dialogName: 'webinar'},
    zwbbasic: {type: addonLearnMoreType.ADDON, dialogName: 'whiteboard', hideOptions: true},
    zwbplus: {type: addonLearnMoreType.ADDON, dialogName: 'zwbplus', hideOptions: true},
    tollfree: {type: addonLearnMoreType.ADDON, dialogName: 'tollfree'},
    'pbx$zpa': {type: addonLearnMoreType.ADDON, dialogName: 'powerPack'},
    'pbx$zpi': {type: addonLearnMoreType.ADDON, dialogName: 'internationalCalling'},
    'pbx$additional': {type: addonLearnMoreType.ADDON, dialogName: 'additionalPhoneNumbers'},
    pro: {type: addonLearnMoreType.PLAN, dialogName: 'pro', hideOptions: true},
    zoneproplus: { type: addonLearnMoreType.PLAN, dialogName: 'zoneproplus', hideOptions: true, title: translation('billing.zone_pro_plus.title') },
    biz: { type: addonLearnMoreType.PLAN, dialogName: 'biz', hideOptions: true, title: translation('billing.planform.title.zoom_one_biz') },
    zonebundle: { type: addonLearnMoreType.PLAN, dialogName: 'zone_bizplus', hideOptions: true , title: translation('billing.planform.title.zoom_one_biz_plus') },
    zoomroom: {type: addonLearnMoreType.PLAN, dialogName: 'zoom_rooms'},
    rc: {type: addonLearnMoreType.ADDON, dialogName: 'rc'},
    eventsaascore: {type: addonLearnMoreType.PLAN, dialogName: 'eventsaascore'},
    custom_avatars: {type: addonLearnMoreType.PLAN, dialogName: 'custom_avatar'},
    workspace_reservation: {type: addonLearnMoreType.PLAN, dialogName: 'workspace_reservation'},
    zvstmgt: {type: addonLearnMoreType.PLAN, dialogName: 'zvstmgt'},
  }
};
